import React from 'react'
import * as FileSaver from 'file-saver'
import * as XLSX from 'xlsx'
import {templateData} from "../../constant/template"

const DownloadTemplate = () => {
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';

    const exportToCSV = (headData, fileName) => {
        const ws = XLSX.utils.json_to_sheet([], {header: headData});

        const wb = {Sheets: {'List customers': ws}, SheetNames: ['List customers']};
        const excelBuffer = XLSX.write(wb, {bookType: 'xlsx', type: 'array'});
        const data = new Blob([excelBuffer], {type: fileType});
        FileSaver.saveAs(data, fileName + fileExtension);
    }

    return <>
        <label>Get file template input <span className="cursor-pointer text-primary"
                                             onClick={() => exportToCSV(templateData, 'customers-template')}>here</span></label>
    </>
}

export default DownloadTemplate
